"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.delegation = exports.encryption = exports.cmc = exports.pryv = void 0;
/**
 * CJS→ESM interop for the pryv package with plugin patching.
 *
 * Default import gives the module.exports object directly (Connection, Auth, etc.).
 * We re-export both the runtime value AND a merged type namespace so that consumers
 * can use `pryv.Connection` as both a constructor and a type annotation.
 */
const pryv_1 = __importDefault(require("pryv"));
const monitor_1 = __importDefault(require("@pryv/monitor"));
const socket_io_1 = __importDefault(require("@pryv/socket.io"));
const _cmc = __importStar(require("@pryv/cmc"));
const _encryption = __importStar(require("@pryv/encryption"));
const _delegation = __importStar(require("@pryv/delegation"));
// @ts-expect-error CJS plugin pattern: module.exports = function(pryv) { ... }
(0, monitor_1.default)(pryv_1.default);
// @ts-expect-error CJS plugin pattern: module.exports = function(pryv) { ... }
(0, socket_io_1.default)(pryv_1.default);
// eslint-disable-next-line import-x/export -- declaration merging: value + type namespace
exports.pryv = pryv_1.default;
exports.cmc = _cmc;
// Official client-side encryption add-on (EventsCipher + Keyring, WebCrypto, zero runtime deps).
// Re-exported so consumers reach it through hds-lib and version-alignment with the embedded
// pryv ecosystem stays hds-lib's responsibility (see healthdatasafe/hds-lib-js#12).
exports.encryption = _encryption;
// Account-delegation client (`delegations.*` API family), for guardian- and
// caregiver-controlled accounts. Re-exported here for the same reason as cmc
// and encryption: consumers must reach the pryv ecosystem through hds-lib, so
// that `pryv` stays a single PATCHED module instance. `Delegation.openControlled`
// builds a `Connection` and therefore needs an explicit `pryv`; callers must pass
// the one exported here (`Delegation.fromConnection(conn, { pryv })`), never a
// direct `import 'pryv'`, which would be a second unpatched instance with
// neither the monitor nor the socket.io plugin applied.
exports.delegation = _delegation;
